module.exports = __webpack_public_path__ + "static/media/Heneritta Bullard Wardrobes (2).bfc8007a.jpg";